import TipoDocumento from 'models/TipoDocumento';
import { del, get, put, post } from './methods';

export default {
  download: (idDocumento: number) => {
    return get<ArrayBuffer>(`documento/${idDocumento}`, {
      responseType: 'arraybuffer',
    });
  },
  update: (data: DocumentoRequestUpdate, idDocumento: number) => put(`documento/${idDocumento}`, data),
  remove: (idDocumento: number) => del(`documento/${idDocumento}`),
  upload: (
    idAssembleia: number,
    idTipoDocumento: number,
    flgVisivel: boolean,
    descricao: string,
    file: File) => {
    const formData: FormData = new FormData();
    formData.append("file", file);
    return post(`documento/assembleia/${idAssembleia}/tipo-documento/${idTipoDocumento}?flgVisivelAssociado=${flgVisivel}&descricao=${descricao}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
};

export const documentoServiceDownload = (
  codigo: string
): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    return get<ArrayBuffer>(`documento/${codigo}`, {
      responseType: 'arraybuffer',
    }).then(
      (response) => {
        resolve(response.data as ArrayBuffer);
      },
      (error) => {
        reject(error);
      },
    );
  });
};

export interface DocumentoResponse {
  idDocumento: number;
  codigo: string;
  nome: string;
  descricao: string;
  tipoDocumento: TipoDocumento;
  flgVisivelAssociado: boolean;
}

export interface DocumentoRequestUpdate {
  descricao: string;
  idTipoDocumento: number,
  flgVisivelAssociado: boolean;
}

export interface DocumentoRequestUpload {
  idAssembleia: number;
  idTipoDocumento: number;
  descricao: string;
  flgVisivelAssociado: boolean;
  tamanho: number;
  nome: string;
  arquivo: File;
}

